
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { FormValues } from "@/types/loan";

interface PersonalBasicInfoFieldsProps {
  form: UseFormReturn<FormValues>;
}

export const PersonalBasicInfoFields = ({ form }: PersonalBasicInfoFieldsProps) => {
  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-3 sm:mb-4">
        <FormField
          control={form.control}
          name="firstName"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-gray-700 mb-1 text-sm block">Etunimi</FormLabel>
              <FormControl>
                <Input 
                  {...field} 
                  placeholder="Etunimi" 
                  className="border-blue-200 focus:border-blue-400 transition-colors h-10 w-full" 
                />
              </FormControl>
              <FormMessage className="text-xs" />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="lastName"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-gray-700 mb-1 text-sm block">Sukunimi</FormLabel>
              <FormControl>
                <Input 
                  {...field} 
                  placeholder="Sukunimi" 
                  className="border-blue-200 focus:border-blue-400 transition-colors h-10 w-full" 
                />
              </FormControl>
              <FormMessage className="text-xs" />
            </FormItem>
          )}
        />
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-3 sm:mb-4">
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-gray-700 mb-1 text-sm block">Sähköposti</FormLabel>
              <FormControl>
                <Input 
                  {...field} 
                  type="email" 
                  placeholder="nimi@esimerkki.fi" 
                  className="border-blue-200 focus:border-blue-400 transition-colors h-10 w-full" 
                />
              </FormControl>
              <FormMessage className="text-xs" />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="phoneNumber"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-gray-700 mb-1 text-sm block">Puhelinnumero</FormLabel>
              <FormControl>
                <Input 
                  {...field} 
                  placeholder="040 123 4567" 
                  className="border-blue-200 focus:border-blue-400 transition-colors h-10 w-full" 
                />
              </FormControl>
              <FormMessage className="text-xs" />
            </FormItem>
          )}
        />
      </div>
    </>
  );
};
